import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const toId = (children) => {
  const text = Array.isArray(children)
    ? children.join('')
    : String(children ?? '');
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
};

// Resolve ::image[token]{alt="..."} → raw HTML with the actual imported URL.
// This avoids rehype-raw stripping unknown URL protocols like "IMG:token".
const resolveContent = (content, images) => {
  return content.replace(
    /::image\[(\w+)\]\{alt="([^"]*)"\}/g,
    (_, key, alt) => {
      const src = images[key] || '';
      return `<div class="article-images"><img loading="lazy" src="${src}" alt="${alt}" /></div>`;
    }
  );
};

const DocsContent = ({ content, images }) => {
  const resolved = resolveContent(content, images);

  const components = {
    h2({ children }) {
      const id = toId(children);
      return <h2 id={id}>{children}</h2>;
    },
    h3({ children }) {
      const id = toId(children);
      return <h3 id={id}>{children}</h3>;
    },
    h4({ children }) {
      const id = toId(children);
      return <h4 id={id}>{children}</h4>;
    },
  };

  return (
    <div className="docs-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={components}
      >
        {resolved}
      </ReactMarkdown>
    </div>
  );
};

export default DocsContent;
